import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-page">
      <div className="about-header">
        <h1>About Revive Wellness Center</h1>
        <p>Nourishing your body, mind, and soul with natural goodness.</p>
      </div>
      
      <section className="about-section">
        <div className="about-content">
          <h2>Our Story</h2>
          <p>Revive Wellness Center was founded in 2018 with a simple mission: to provide delicious, nutrient-dense foods that support optimal health and wellbeing.</p>
          <p>What started as a small juice bar has grown into a community hub for health-conscious individuals looking for fresh, organic options that don't compromise on taste.</p>
          <p>Our founder, Sarah Johnson, was inspired to create Revive after her own health journey led her to discover the transformative power of whole, plant-based foods. After experiencing the benefits firsthand, she became passionate about making these options more accessible to everyone.</p>
        </div>
        <div className="about-image">
          <div className="image-placeholder">Our Story Image</div>
        </div>
      </section>
      
      <section className="about-section reverse">
        <div className="about-content">
          <h2>Our Philosophy</h2>
          <p>At Revive, we believe that what you put into your body matters. That's why we source the freshest, highest quality ingredients for all our products.</p>
          <p>We're committed to:</p>
          <ul>
            <li>Using organic ingredients whenever possible</li>
            <li>Supporting local farmers and suppliers</li>
            <li>Creating products that are both nutritious and delicious</li>
            <li>Minimizing our environmental impact through sustainable practices</li>
            <li>Creating a welcoming space for everyone in our community</li>
          </ul>
        </div>
        <div className="about-image">
          <div className="image-placeholder">Our Philosophy Image</div>
        </div>
      </section>
      
      <section className="team-section">
        <h2>Meet Our Team</h2>
        <div className="team-grid">
          <div className="team-member">
            <div className="member-image">
              <div className="image-placeholder">Team Member</div>
            </div>
            <h3>Sarah Johnson</h3>
            <p className="member-title">Founder & Nutrition Coach</p>
            <p>Sarah is a certified nutrition coach with a passion for helping others discover the healing power of whole foods.</p>
          </div>
          
          <div className="team-member">
            <div className="member-image">
              <div className="image-placeholder">Team Member</div>
            </div>
            <h3>Michael Chen</h3>
            <p className="member-title">Head Chef</p>
            <p>Michael brings his culinary expertise to create innovative, nutritious recipes that keep our customers coming back.</p>
          </div>
          
          <div className="team-member">
            <div className="member-image">
              <div className="image-placeholder">Team Member</div>
            </div>
            <h3>Emily Rodriguez</h3>
            <p className="member-title">Wellness Coordinator</p>
            <p>Emily coordinates our wellness programs and ensures every customer has a positive experience at Revive.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;